export const enum FrameType {
    SlideList = "SlideListFrame",
    PanoramaVFT = "PanoramaVFTFrame",
    Empty = "EmptyFrame"
}